if (!customElements.get('os-countdown')) {
  customElements.define(
    'os-countdown',
    class OsCountdown extends HTMLElement {
      connectedCallback() {
        this.deadline = new Date(this.dataset.deadline).getTime();
        this.slots = {
          days: this.querySelector('[data-slot="days"]'),
          hours: this.querySelector('[data-slot="hours"]'),
          minutes: this.querySelector('[data-slot="minutes"]'),
          seconds: this.querySelector('[data-slot="seconds"]'),
        };
        if (Number.isNaN(this.deadline)) return;
        this.tick();
        this.interval = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }

      tick() {
        let diff = Math.max(0, this.deadline - Date.now());
        const days = Math.floor(diff / 86400000);
        diff -= days * 86400000;
        const hours = Math.floor(diff / 3600000);
        diff -= hours * 3600000;
        const minutes = Math.floor(diff / 60000);
        diff -= minutes * 60000;
        const seconds = Math.floor(diff / 1000);
        this.slots.days.textContent = days;
        this.slots.hours.textContent = hours;
        this.slots.minutes.textContent = minutes;
        this.slots.seconds.textContent = seconds;
      }
    }
  );
}
